import React, { PropTypes } from 'react'
import { rhythm } from '../../utils/typography'
import './style.less'

function Divider(props) {
  const { } = props

  return (
    <hr
      className="divider"
      style={{
        margin: `${rhythm(3)} 0`,
      }}
    />
  )
}

Divider.propTypes = {

}

Divider.defaultProps = {

}

export default Divider



// WEBPACK FOOTER //
// ../components/Divider/index.js